import { baseColors } from "../../../../../../themes/definitions/mrgreen/base-colors";
import {SearchTitleDefaultBox} from "./search-title.default.box";
import styled from "styled-components";

export const SearchTitleMrGreenMiniOrbitBox = styled(SearchTitleDefaultBox)`
    color:${baseColors.warmWhite};
`;
